import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ProductsEffects } from '@appStore/products/effects/products.effects';
import { AgreementEffects } from '@appStore/products/effects/agreement.effects';
import { ServiceAgreementsEffects } from '@appStore/products/effects/service-agreements.effects';

export const effects: any[] = [ 
  ProductsEffects, 
  AgreementEffects, 
  ServiceAgreementsEffects 
];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class ProductsEffectsModule {}
